import { BackendValue, BackendValueRecord } from '../widget-data.model';

export enum ComponentSubType {
  Bar = 'bar',
  Pie = 'pie',
  Treemap = 'treemap',
  Scatter = 'scatter',
  Funnel = 'funnel',
  Line = 'line',
  Area = 'area',
  Table = 'table',
  CohortTable = 'cohort_table',
}

type ChartSubType =
  | ComponentSubType.Bar
  | ComponentSubType.Line
  | ComponentSubType.Pie
  | ComponentSubType.Area
  | ComponentSubType.Treemap
  | ComponentSubType.Scatter
  | ComponentSubType.Funnel;

export interface WidgetClickContext<T extends ComponentSubType = ComponentSubType> {
  componentSubType: T;
  value: BackendValueRecord;
}

export interface ChartClickContext<T extends ChartSubType = ChartSubType> extends WidgetClickContext<T> {
  data: {
    additionalData?: BackendValueRecord;
  };
  name: string;
  seriesName: string;
  event: Event & { event: PointerEvent };
}

export interface TreeMapClickEvent extends ChartClickContext<ComponentSubType.Treemap> {
  treePathInfo: Array<{ name: string; dataIndex: number; value: BackendValue }>;
}
